import routes from 'js/core_pre_webpack/routes';

type Params = {
  hasUnseenUploadableStubs: boolean;
  hasUnseenClaimablePapers: boolean;
  trigger: 'nav' | 'tools';
};

export function uploadUrl({
  hasUnseenUploadableStubs,
  hasUnseenClaimablePapers,
  trigger,
}: Params) {
  return hasUnseenClaimablePapers
    ? routes.claim_papers_claim_mentions_url({
        skip_to: encodeURIComponent(routes.upload_funnel_url()),
        from_navbar: true,
        trigger,
      })
    : hasUnseenUploadableStubs
      ? routes.claim_papers_stubs_mentions_url({
          skip_to: encodeURIComponent(routes.upload_funnel_url()),
          from_navbar: true,
          trigger,
        })
      : routes.upload_funnel_url({
          from_navbar: true,
          trigger,
        });
}
